import { nanoid } from 'nanoid';

import { WorkflowNodeType, DataSourceType, NodeFieldsEnum } from '../constants';
import { FlowNodeRegistry } from '../../typings';
import iconSql from '../../assets/icon-sql.png';
import { formMeta } from './sql-meta';

// 定义SQL节点注册信息
const SQLNodeRegistry: FlowNodeRegistry = {
  type: WorkflowNodeType.Sql,
  label: '执行SQL',
  meta: {},
  info: {
    icon: iconSql,
    description: '执行sql代码',
  },
  formMeta,
  onAdd(ctx) {
    return {
      id: `${WorkflowNodeType.Sql}_${nanoid(5)}`,
      type: WorkflowNodeType.Sql,
      data: {
        title: '执行SQL',
        fields: [{ key: NodeFieldsEnum.dataSource, value: DataSourceType.BELINK }],
      },
    };
  },
};

export { SQLNodeRegistry };
